import { Theme } from "@mui/material";

export const buttonStyles = (theme: Theme) => ({
  mt: 2,
  borderRadius: "9999px",
  backgroundColor: theme.palette.outlinedButton.bd,
  border: "1px solid #06B6D4",
  color: "#06B6D4",
  textTransform: "none",
  fontWeight: 500,
  px: 4,
  py: 1,
  "&:hover": {
    backgroundColor: theme.palette.outlinedButton.bgHover,
    borderColor: "#06B6D4",
  },
});
